import React from 'react';

function SvgFbSolidV2({ size = 30 }) {
  return (
    <svg height={size} viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.36842 22.1667V12.4688H11.0526L11.6667 8.3125H7.36842V6.23438C7.36842 4.84896 7.98368 4.15625 9.21053 4.15625H11.0526V0C10.4386 0 9.06316 0 7.98246 0C4.91228 0 3.68421 2.07812 3.68421 5.54167V8.3125H0V12.4688H3.68421V22.1667H7.36842Z" fill="#3B5998"/>
    </svg>
  );
}

export default SvgFbSolidV2;
